var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49335 7.75C8.92125 7.75 11.2083 9.43114 12.4558 12.1421C13.0795 13.5006 12.6905 15.0701 11.49 16.044C10.3297 16.987 8.90113 17.5701 7.36525 17.7314L7.28477 17.7376C7.0232 17.7438 6.76163 17.75 6.50006 17.75C6.23849 17.75 5.97692 17.7438 5.71535 17.7376L5.63487 17.7314C4.09229 17.5701 2.66372 16.987 1.51013 16.044C0.309601 15.0701 -0.0793977 13.5006 0.544343 12.1421C1.77841 9.43114 4.06546 7.75 6.49335 7.75Z",
    fill: "#34657F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48086 6.82282C4.66028 6.82282 3.17437 5.35029 3.17437 3.53641C3.17437 1.72253 4.65359 0.25 6.48086 0.25C8.30144 0.25 9.78735 1.72253 9.78735 3.53641C9.78735 5.35029 8.30144 6.82282 6.48086 6.82282Z",
    fill: "#34657F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailTypeIcon);
export default __webpack_public_path__ + "static/media/retail-type-icon.c5d3559f3d4105d97c7ac44da9493baa.svg";
export { ForwardRef as ReactComponent };